import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TimeAgoPipe} from './timeago.pipe';
import { PhoneNumberPipe } from './phone-number.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    TimeAgoPipe,
    PhoneNumberPipe
  ],
  exports: [
    TimeAgoPipe,
    PhoneNumberPipe
  ]
})
export class PipesModule { }
